export enum ActionsIds {
  rowKeyDown = 'rowKeyDown',
  rowClick = 'rowClick',
  delete = 'delete',
  edit = 'edit',
  iconClick = 'iconClick',
}
